export function wsUrl() {
  const apiBase = process.env.API_BASE_URL;
  if (apiBase) return apiBase.replace(/^http/, 'ws');
  const proto = window.location.protocol === 'https:' ? 'wss' : 'ws';
  return `${proto}://${window.location.host}`;
}
